(() => {
  const portal = document.querySelector('[data-obp-native-portal]');
  const form = portal?.querySelector('[data-obp-native-form]');
  if (!portal || !form) return;

  const quantities = Array.from(form.querySelectorAll('[data-obp-native-quantity]'));
  const submit = form.querySelector('[data-obp-native-submit]');
  const count = form.querySelector('[data-obp-native-count]');
  const message = form.querySelector('[data-obp-native-message]');
  const search = portal.querySelector('[data-obp-native-search]');
  let busy = false;

  const normalize = (value) => String(value || '').toLocaleLowerCase('de-DE').normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  const validQuantity = (input) => {
    const value = Math.max(0, Number.parseInt(input.value || '0', 10) || 0);
    if (value === 0) return 0;
    const minimum = Number.parseInt(input.dataset.orderMin || '1', 10) || 1;
    const increment = Number.parseInt(input.dataset.orderIncrement || '1', 10) || 1;
    if (value < minimum) return minimum;
    return minimum + Math.ceil((value - minimum) / increment) * increment;
  };

  const updateSummary = () => {
    const total = quantities.reduce((sum, input) => sum + validQuantity(input), 0);
    count.textContent = total === 1 ? '1 Artikel ausgewählt' : `${total} Artikel ausgewählt`;
    submit.disabled = total === 0 || busy;
  };

  form.addEventListener('click', (event) => {
    const button = event.target.closest('[data-obp-native-increase], [data-obp-native-decrease]');
    if (!button) return;
    const input = button.parentElement.querySelector('[data-obp-native-quantity]');
    const minimum = Number.parseInt(input.dataset.orderMin || '1', 10) || 1;
    const increment = Number.parseInt(input.dataset.orderIncrement || '1', 10) || 1;
    const current = Number.parseInt(input.value || '0', 10) || 0;
    if (button.hasAttribute('data-obp-native-increase')) input.value = current === 0 ? minimum : current + increment;
    else input.value = current <= minimum ? 0 : Math.max(minimum, current - increment);
    updateSummary();
  });

  form.addEventListener('input', (event) => {
    if (event.target.matches('[data-obp-native-quantity]')) updateSummary();
  });

  quantities.forEach((input) => input.addEventListener('change', () => {
    input.value = validQuantity(input);
    updateSummary();
  }));

  search?.addEventListener('input', () => {
    const query = normalize(search.value);
    form.querySelectorAll('[data-obp-native-row]').forEach((row) => {
      const haystack = normalize(`${row.dataset.productTitle} ${row.dataset.productSku}`);
      row.hidden = Boolean(query) && !haystack.includes(query);
    });
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (busy) return;
    const items = quantities.map((input) => ({ id: Number(input.dataset.variantId), quantity: validQuantity(input) })).filter((item) => item.quantity > 0);
    if (!items.length) return;

    busy = true;
    message.textContent = 'Ihre Auswahl wird vorbereitet …';
    updateSummary();

    try {
      const response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.description || 'Die Auswahl konnte nicht in den Warenkorb gelegt werden.');
      }
      window.location.assign(window.theme?.routes?.cart_url || '/cart');
    } catch (error) {
      busy = false;
      message.textContent = error.message || 'Bitte versuchen Sie es erneut oder kontaktieren Sie unser B2B Sales Team.';
      updateSummary();
    }
  });

  updateSummary();
})();
